import { render } from "./addinformation.vue?vue&type=template&id=6fd8e76f&scoped=true"
import script from "./addinformation.vue?vue&type=script&lang=js"
export * from "./addinformation.vue?vue&type=script&lang=js"

import "./addinformation.vue?vue&type=style&index=0&id=6fd8e76f&lang=scss&scoped=true"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd8e76f"]])

export default __exports__